import { Controller } from "@hotwired/stimulus";

// Copia data-clipboard-text-value para a área de transferência sem seguir o link em volta do botão.
export default class extends Controller {
  static values = { text: String, copiedLabel: String };

  copy(event) {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard?.writeText(this.textValue);
    if (this.copiedLabelValue) this.element.textContent = this.copiedLabelValue;
  }
}
